import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { contactInfo } from '../utils/mockData';

export const FinalCTASection = () => {
  const handleWhatsApp = (message) => {
    const url = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section id="kontak" className="py-20 bg-[#D32F2F] scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
            Siap Mengembangkan Brand Digital Anda?
          </h2>
          <p className="text-xl text-white/90">
            Konsultasikan kebutuhan digital marketing Anda bersama Dreams Marketing.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => handleWhatsApp('Halo, saya ingin konsultasi gratis dengan Dreams Marketing.')}
              className="bg-white text-[#D32F2F] hover:bg-gray-100 px-8 py-6 text-lg"
            >
              Konsultasi Gratis via WhatsApp
              <MessageCircle className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => handleWhatsApp('Halo, saya ingin jadwalkan meeting dengan Dreams Marketing.')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#D32F2F] px-8 py-6 text-lg"
            >
              Jadwalkan Meeting
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
